export function mapNestedTree<TResult = any>(data: any[] = [], cb?: (item: any) => TResult): TResult[] {
  const callback = cb ? cb : (item: any) => item;
  return data.map((item) => {
    if (item?.viagsDepartmentChild && item?.viagsDepartmentChild?.length > 0) {
      return { ...item, ...callback(item), children: mapNestedTree(item.viagsDepartmentChild, cb) };
    }
    return { ...item, ...callback(item) } as any;
  });
}
